<template>
  <div class="rptMenu" @blur="blurMenu()">
    <i class="fa fa-sort-desc" v-show="!isOpened" @click="isOpened=true"></i>
    <div class="rptMenuList" v-show="isOpened">
      <i class="fa fa-times rptMenu" style="top: 0px;" @click="isOpened=false"></i>
      <div class="rptMenuItems">
        <span class="text-sm">Label:</span>
        <div>
          <select v-model="mDataItem" style="width: 100%;">
            <option v-for="dataItem in dataItems" :value="dataItem.fieldName">{{dataItem.label}}</option>
          </select>
        </div>
        <span class="text-sm">Data Item:</span>
        <div>
          <select v-model="mDataItem" style="width: 100%;">
            <option v-for="dataItem in dataItems" :value="dataItem.fieldName">{{dataItem.label}}</option>
          </select>
        </div>
        <div class="box-tools pull-right">
          <span class="text-sm">Text Align:</span>
          <ul class="pagination pagination-sm" style="margin: 0px;">
            <li>
              <a @click="elmData.align='left'" :class="['noselect', elmData.align==='left'?'activePage':'']">
                <i class="fa fa-align-left"></i>
              </a>
            </li>
            <li>
              <a @click="elmData.align='center'" :class="['noselect', elmData.align==='center'?'activePage':'']">
                <i class="fa fa-align-center"></i>
              </a>
            </li>
            <li>
              <a @click="elmData.align='right'" :class="['noselect', elmData.align==='right'?'activePage':'']">
                <i class="fa fa-align-right"></i>
              </a>
            </li>
          </ul>
        </div>
        <div class="box-tools pull-right">
          <span class="text-sm">Font Weight:</span>
          <ul class="pagination pagination-sm" style="margin: 0px;">
            <li>
              <a @click="elmData.bold=true" :class="['noselect', elmData.bold?'activePage':'']">
                Bold
              </a>
            </li>
            <li>
              <a @click="elmData.bold=false" :class="['noselect', !elmData.bold?'activePage':'']">
                None
              </a>
            </li>
          </ul>
        </div>
        <span class="text-sm">Font Size:</span>
        <div>
          <select v-model="mFontSize" style="width: 100%;" @change="changeFontSize">
            <option v-for="fontSize in fontSizeList" :value="fontSize">{{fontSize}}</option>
          </select>
        </div>
        <div style="margin-top: 10px; border-top: 1px solid #ddd;">
          <a @click="$emit('removeClicked', index)"  class="noselect" style="font-size: 12px;">
            <i class="fa fa-trash-o"></i> Remove Item
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'ReportMenu',
    props: ['elmData', 'index'],
    data () {
      return {
        isOpened: false,
        mFontSize: '14px',
        fontSizeList: ['8px', '10px', '12px', '14px', '16px', '18px', '20px'],
        fontSizePx: '14px',
        mDataItem: '',
        dataItems: [
          { fieldName: 'Status', label: 'Status' },
          { fieldName: 'Logged', label: 'Date' },
          { fieldName: 'MacAddress', label: 'MAC Address' },
          { fieldName: 'PrinterSerial', label: 'Serial' },
          { fieldName: 'ModelName', label: 'Model' },
          { fieldName: 'IPAddress', label: 'IP Address' },
          { fieldName: 'PageCount', label: 'Pages' },
          { fieldName: 'HostName', label: 'Host' },
          { fieldName: 'Location', label: 'Location' },
          { fieldName: 'Dealer', label: 'Dealer' },
          { fieldName: 'Customer', label: 'Customer' },
          { fieldName: 'Site', label: 'Site' },
          { fieldName: 'ErrorString', label: 'Error' },
          { fieldName: 'A4Black', label: 'A4 Black' },
          { fieldName: 'A4Color', label: 'A4 Color' },
          { fieldName: 'A3Black', label: 'A3 Black' },
          { fieldName: 'A3Color', label: 'A3 Color' },
          { fieldName: 'Copy', label: 'Copy' },
          { fieldName: 'Scan', label: 'Scan' },
          { fieldName: 'Duplex', label: 'Duplex' },
          { fieldName: 'Fax', label: 'Fax' },
          { fieldName: 'BlackTonerLeft', label: 'Black' },
          { fieldName: 'CyanTonerLeft', label: 'Cyan' },
          { fieldName: 'MagentaTonerLeft', label: 'Magenta' },
          { fieldName: 'YellowTonerLeft', label: 'Yellow' },
          { fieldName: 'PAGE_NUMBER', label: 'Page Number' },
          { fieldName: 'PAGE_COUNT', label: 'Pages Count' }
        ]
      }
    },
    mounted () {
      // console.log('ReportMenu mounted()...')
      this.mFontSize = this.elmData.fontsize ? this.elmData.fontsize + 'px' : '14px'
      this.mDataItem = this.elmData.text ? this.elmData.text : ''
    },
    computed: {
      menuCss () {
        return {
          position: 'absolute',
          top: this.elmData.top + 'in',
          left: this.elmData.left + 'in',
          width: this.elmData.width + 'in',
          height: this.elmData.height + 'in',
          fontWeight: this.elmData.bold ? 'bold' : '',
          backgroundColor: this.elmData.background_color,
          border: '1px dotted rgba(0,0,0,0.5)',
          zIndex: 0,
          fontSize: '14px'
        }
      }
    },
    methods: {
      blurMenu () {
        // this.isOpen = false
      },
      changeTextAlign () {
        this.elmData.align = this.mTextAlign
      },
      changeFontSize () {
        this.elmData.fontsize = this.mFontSize.replace('px', '')
      }
    }
  }
</script>
<style>
  .rptMenu {
    position: absolute;
    cursor: pointer;
    top: -5px;
    right: 0;
    text-align: left!important;
    font-size: 14px;
  }
  .rptMenuList {
    position: absolute;
    right: 1px;
    top: 5px;
    border: 1px solid #ddd;
    background-color: #eee;
    border-radius: 2px;
    z-index: 2000 !important;
  }
  .rptMenuItems {
    margin-top: 10px;
    padding: 5px;
    cursor: pointer;
    width: 110px;
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// ReportMenu.vue?66d64850